const CALI_SP_BOOKING_BASE = 'https://reservecalifornia.com';

function toIsoDate(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value.trim())) {
    return value.trim().slice(0, 10);
  }
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString().slice(0, 10);
}

/**
 * ReserveCalifornia park + facility deeplink.
 * Parks.ca.gov availability pages prefill with ?date=YYYY-MM-DD&night=N
 */
export function buildCaliSpBookingUrl({
  parkPlaceId,
  facilityId,
  date,
  nights,
} = {}) {
  if (parkPlaceId == null || facilityId == null) {
    return `${CALI_SP_BOOKING_BASE}/`;
  }
  const path = `${CALI_SP_BOOKING_BASE}/park/${parkPlaceId}/${facilityId}`;
  const arrival = toIsoDate(date);
  if (!arrival) return path;
  const nightCount = Math.max(1, Math.round(Number(nights) || 1));
  return `${path}?date=${arrival}&night=${nightCount}`;
}

export function buildCaliSpBookingUrlForOuting({ outing, date, nights } = {}) {
  if (!outing) return `${CALI_SP_BOOKING_BASE}/`;
  return buildCaliSpBookingUrl({
    parkPlaceId: outing.parent_id ?? outing.parentId?.entity_id,
    facilityId: outing.entity_id,
    date,
    nights,
  });
}
